import * as React from "react";
import { BlobProvider } from "@react-pdf/renderer";

import { Button } from "src/library/components/Button";
import { Icons } from "src/library/components/Icon/types";

import OrderPDF, { OrderPDFProps } from "./OrderPDF/OrderPDF";

export interface DownloadOrderPDFButtonProps extends OrderPDFProps {
  openPrintOnLoad?: boolean;
}

// returns a button that will generate a pdf from an order
const DownloadOrderPDFButton: React.ReactFCWithChildren<DownloadOrderPDFButtonProps> = ({
  openPrintOnLoad, drop, order, ...rest
}) => {
  return (
    <BlobProvider
      document={(
        <OrderPDF
          drop={drop}
          order={order}
          {...rest}
        />
      )}
    >
      {({ loading, blob }) => {
        // open printable order tab as soon as ready if consumer desires
        if (openPrintOnLoad && blob) {
          window.open(URL.createObjectURL(blob));
        }

        return (
          <Button
            $buttonType="plain"
            loading={loading}
            icon={Icons.PRINTER}
            onClick={() => {
              if (blob) {
                window.open(URL.createObjectURL(blob));
              }
            }}
          >
            Print Order PDF
          </Button>
        );
      }}
    </BlobProvider>
  );
};

export default DownloadOrderPDFButton;
